import { render } from "./OfferDetails.vue?vue&type=template&id=6df5b070"
import script from "./OfferDetails.vue?vue&type=script&lang=js"
export * from "./OfferDetails.vue?vue&type=script&lang=js"

import "./OfferDetails.vue?vue&type=style&index=0&id=6df5b070&lang=css"
import "./OfferDetails.vue?vue&type=style&index=1&id=6df5b070&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__